import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from '../styles/uikitInputsDependentRadioSets.module.scss';

const DependentRadioSets = ({ className = '', radioSets = [] }) => (
  <div className={classnames(styles.element, className)}>
    {radioSets.map((radioSet, index) => (
      <div
        key={radioSet.props.fieldKey || index}
        className={classnames('dependentRadioSet', styles.radioSet, radioSet.props.className)}
      >
        {radioSet}
      </div>
    ))}
  </div>
);

DependentRadioSets.propTypes = {
  className: PropTypes.string,
  radioSets: PropTypes.arrayOf(PropTypes.element),
};

export default DependentRadioSets;
